<template>
  <div class="modal fade" id="ModePaiementModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="ModePaiementModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ selectedItem ? 'Modifier' : 'Ajouter' }} un mode de paiement</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="modePaiementForm" @submit="soumettre" :validation-schema="modePaiementSchema">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="code" v-model="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le code" />
                  <ErrorMessage name="code" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Libellé <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" v-model="libelle" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le libellé" />
                  <ErrorMessage name="libelle" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">
                  {{ selectedItem ? 'Modifier' : 'Enregistrer' }}
                </button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { hideModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";

export default defineComponent({
  name: "ModePaiementModal",
  components: { Form, Field, ErrorMessage },
  props: {
    item: { type: [String, Number, null], default: null },
  },
  setup: (props, { emit }) => {
    const modePaiementSchema = Yup.object().shape({
      code: Yup.string().required("Le code est obligatoire"),
      libelle: Yup.string().required("Le libellé est obligatoire"),
    });

    const modePaiementForm = ref<any | null>(null);
    const code = ref("");
    const libelle = ref("");
    const selectedItem = ref<any>(null);
    const ModePaiementModalRef = ref<null | HTMLElement>(null);

    const resetForm = () => {
      code.value = "";
      libelle.value = "";
      selectedItem.value = null;
    };

    const getModePaiement = async (id: number | string) => {
      try {
        // TODO: Ajouter route GET /api/mode/paiement/:id au backend
        error("Route de récupération non encore implémentée au backend");
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    watch(() => props.item, async (newValue) => {
      if (newValue !== null && newValue !== undefined) {
        await getModePaiement(newValue);
      } else {
        resetForm();
      }
    }, { immediate: true });

    const soumettre = async (values, { resetForm }) => {
      try {
        // TODO: Ajouter routes POST/PUT au backend
        if (selectedItem.value && selectedItem.value.id) {
          // const response = await axios.put(`/api/mode/paiement/${selectedItem.value.id}`, values);
          error("Route de modification non encore implémentée au backend");
        } else {
          const response = await axios.post("mode/paiement", values);
          if (response.data && response.data.data) {
            success("Le mode de paiement a été enregistré avec succès");
            resetForm();
            hideModal(ModePaiementModalRef.value);
            emit("close");
          }
          else {
            error("Une erreur est survenue");
          }
        }
      } catch (err) {
        error(err instanceof AxiosError ? err.response?.data?.message || "Une erreur est survenue" : "Une erreur est survenue");
      }
    };

    return {
      code,
      libelle,
      selectedItem,
      ModePaiementModalRef,
      soumettre,
      modePaiementSchema,
      modePaiementForm,
    };
  },
});
</script>

